import iconDoc from "assets/images/icons/uploadcloud.svg";

const FileUploadUI = (props) => {
    const selectText = props.selectText;
    const fileIcon = props.fileIcon || iconDoc;


    return (
        <div className="w-full h-full p-6 bg-[#FBFCFF] flex items-center justify-center text-center cursor-pointer">
            <div>
                <div className="h-5 flex">
                    <img src={fileIcon} alt="file upload" className="object-contain mx-auto" />
                </div>
                {/* <div className="mt-4 font-medium text-ep-primary">
                    {selectText}
                </div> */}
                <div className="text-fade">
                  Drag and drop file or <a className="text-[#00535C] underline">browse</a>
                </div>
            </div>
        </div>
    )
}

export default FileUploadUI
